import imagePiede from '../../assets/trattamenti/Piede-caviglia.jpg';
import BackgroundImgBlur from '../../components/BackgroundImgBlur';


export default function CavigliaPiede() {
    const cavigliaPiedeContent = <>
     <ul className='text-left'>
        <li className="mb-5 pb-3 border-b-2 border-[#65806E] ">
        <b> Distorsioni, Fascite Plantare, Lesioni Osteocondrali: </b> <br /> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia, onde d’urto focali.
        </li>
    </ul>
    </>
    return <>
            <BackgroundImgBlur src={imagePiede} title={'CAVIGLIA E PIEDE'} content={cavigliaPiedeContent} hscreen={true}/>
    </>
}